import { render, staticRenderFns } from "./selectModal.vue?vue&type=template&id=0247b32b&scoped=true"
import script from "./selectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./selectModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./selectModal.vue?vue&type=style&index=0&id=0247b32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247b32b",
  null
  
)

export default component.exports